export default __webpack_public_path__ + "static/media/ods5.da45e9f9.svg";